const safeGet = (data, path) => {
    if (!path) return undefined
    let paths = path.split('.')
    let res = data
    while (paths.length) {
        res = res[paths.shift()]
        if (!res) return undefined
    }
    return res
}

export {safeGet}



// WEBPACK FOOTER //
// ./packages/utils/safeGet.js